import React from 'react'
import { generatePDF } from '../src/api/generatePdf'
import { FileExtension } from '../src/utils/mimeTypeToFileExtension'
import { CardDownload } from './CardDownload'
import SvgAntiSlip from './icons/SvgAntiSlip'
import SvgPdf from './icons/SvgPdf'
import { Button } from './Button'
import SvgPrint from './icons/SvgPrint'

export interface ExportButtonProps {
	filename: string
	documentClassName?: string 
	html?: string
	landscape?: boolean
}

export const ExportButton: React.FunctionComponent<ExportButtonProps> = ({
	children, documentClassName, html, landscape, filename
}) => {
	const [loading, setLoading] = React.useState<boolean>(false);

	return (
		<div className='exportButton'>
			<Button
				loading={loading}
				icon={<SvgPrint/>}
				onClick={async (e) => {
					e.preventDefault();

					setLoading(true);
					try {
						html = html ?? document.body.innerHTML ?? '';
						const response = await generatePDF({
							html: html,
							className: documentClassName ?? ''
						});
						const doc = (response as any).data.documentBase64;
					
						const d = new Date();
						const a = document.createElement("a"); 
						a.href = "data:application/octet-stream;base64," + doc;
						a.download = `${filename}_${d.getFullYear()}${(d.getMonth() + 1).toString().padStart(2, '0')}${d.getDate().toString().padStart(2, '0')}.pdf`;
						a.click(); 
					}
					finally 
					{
						setLoading(false);
					}
				}}	
			>
				{children}
			</Button>
		</div>
	)
}
